import zhTW from "./zh-tw"
import zhCN from "./zh-cn"
import enUS from "./en-us"

export default {
  "zh-tw": zhTW,
  "zh-cn": zhCN,
  "en-us": enUS,
}
